var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price-wrap text-center"},[_c('div',{staticClass:"price-div display-2"},[_c('span',{staticClass:"display-1 font-weight-light"},[_vm._v(_vm._s(_vm.$t('yourConfig')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }